import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'app-survey-create',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './survey-create.component.html',
  styleUrl: './survey-create.component.css'
})
export class SurveyCreateComponent {
  name = '';
  submitting = false;
  errorMessage: string | null = null;

  constructor(
    private readonly admin: AdminService,
    private readonly router: Router
  ) {}

  submit(): void {
    const n = (this.name ?? '').trim();
    if (!n) {
      this.errorMessage = 'Survey name is required.';
      return;
    }
    this.submitting = true;
    this.errorMessage = null;
    this.admin.createSurveyType({ name: n }).subscribe({
      next: (created) => {
        this.router.navigate(['/admin/survey-types', created.id, 'edit']);
      },
      error: (err: Error) => {
        this.errorMessage = err?.message ?? 'Failed to create osaf_survey.';
        this.submitting = false;
      }
    });
  }
}
